import { subMenuOptions } from '../constants/subMenuOptions'

const getSubMenuOptionId = path =>
  subMenuOptions.find(({ path: opitonPath }) => opitonPath === path)?.id

export { getSubMenuOptionId }
